'use es6';

import Actions from 'AdsUI/lib/Actions';
import * as CampaignListData from 'AdsUI/data/CampaignListData';
import { wrapReduxAction } from 'AdsUI/lib/ActionWrapper';
import store from 'AdsUI/redux-store';
import fetchWithEarlyRequester from 'AdsUI/lib/fetchWithEarlyRequester';
import { fromGlobalFilters } from 'AdsUI/records/reporting/CampaignListFilterRecord';
import { fromGlobalFilters as sequenceRecordFromGlobalFilters } from 'AdsUI/records/reporting/SequenceListFilterRecord';
export const fetchCampaignList = filters => {
  return dispatch => {
    return wrapReduxAction(CampaignListData.fetch.bind(CampaignListData, filters), 'CAMPAIGN_LIST_FETCH', {
      allParams: {
        filters: fromGlobalFilters(filters)
      },
      dispatch
    });
  };
};
export const fetchCampaignListEarlyRequest = filters => {
  return function (dispatch) {
    return wrapReduxAction(() => fetchWithEarlyRequester(CampaignListData.fetchEarlyRequest.bind(CampaignListData, filters), 'campaigns-prefetch'), 'CAMPAIGN_LIST_EARLY_REQUEST_FETCH', {
      allParams: {
        filters: fromGlobalFilters(filters)
      },
      dispatch
    });
  };
};
export const dispatchResetState = () => {
  store.dispatch({
    type: Actions.CAMPAIGN_LIST_RESET
  });
  store.dispatch({
    type: Actions.CHILD_ENTITY_FETCH_RESET
  });
};
export const resetTrackingStatus = () => dispatch => {
  dispatch({
    type: Actions.CAMPAIGN_LIST_RESET
  });
  dispatch({
    type: Actions.ENTITY_TRACKING_STATUS_INVALIDATE
  });
};
export const fetchAllAdSequences = filters => {
  return dispatch => {
    return wrapReduxAction(CampaignListData.fetchAllAdSequences.bind(CampaignListData, filters), 'SEQUENCE_LIST_FETCH', {
      allParams: {
        filters: sequenceRecordFromGlobalFilters(filters)
      },
      dispatch
    });
  };
};